import { OutputSettings } from '@/models/Output';
import { ReportPublications } from '@/models/Publication';

export default {
	methods: {
		setStoreReportPublications(reportId) {
			const publications = new ReportPublications();
			publications.set('id', reportId);
			publications.fetch().then(() => {
				this.$store.set('reportPublications', publications.models);
			}).catch((e) => {
				dump('Error fetching report publications', e);
				this.checkError(e);
				this.$notify('error', 'Failed to retrieve Publications.');
			});
		},
		setStoreOutputSettings() {
			const outputSettings = new OutputSettings();
			outputSettings.projectId = this.$store.get('projects/currentProject').id;
			outputSettings.fetch().then(() => {
				this.$store.set('markdownOptions', outputSettings.markdownOptions);
				this.$store.set('outputSortSettings', outputSettings.sortSettings);
			}).catch((e) => {
				dump('Error fetching output settings', e);
				this.$notify('error', 'Failed to retrieve Output Settings');
			});
		},
		checkError(error) {
			if (process.env.NODE_ENV !== 'development') {
				this.$bugsnag.notify(new Error(`${error}`), { metaData: error });
			}
			this.$router.replace({ name: 'Error', params: { to: { name: 'Dashboard' } } });
		},
	},
};
